export const EMAIL_MAX_LENGTH = 254;
export const EMAIL_MIN_LENGTH = 6;
export const NAME_MAX_LENGTH = 40;
export const NAME_MIN_LENGTH = 1;
export const PASSWORD_MAX_LENGTH = 100;
export const PASSWORD_MIN_LENGTH = 8;

export const EMAIL_REGEX =
  /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
